import {BDCheckboxFilter} from '@brother-apps/brother-dealerapp-shared-lib';

export class MyFilterModel {
    // stores filter state before the choices are really applied on the project list
    // the way how to apply the choices is the copy/convert current choices state to the activeFilterValues
    // then the changes still must be applied/handled manually with root-page methods
    choices: BDCheckboxFilter[];

    // also is used to indicate if the "apply filter button" should be active or disabled
    filterValueChanged: boolean;

    // contains filter values which is currently used (applied on project list),
    // so if this list differ from choices, the filterValueChanged should be true
    activeFilterValues: string[];

    isResetBtnActive: boolean;

    /**
     *
     * compare choices and activeFilerValues and used the result to  set isResetBtnActive and filterValueChanged
     * @memberof MyFilterModel
     */
    public refreshFilterBtnStates(): void {
        // console.log('refreshFilterBtnStates', this);
        this.isResetBtnActive = false;
        this.filterValueChanged = false;

        this.choices.forEach(choice => {
            this.isResetBtnActive = this.isResetBtnActive || choice.selected;
            this.filterValueChanged = this.filterValueChanged ||
                (this.arrayContainsValue(this.activeFilterValues, choice.label) !== !!choice.selected);
        });
    }

    private arrayContainsValue<T>(array: T[], value: T): boolean {
        return array.findIndex(arrValue => arrValue === value) > -1;
    }

    /**
     * copy filter choices to filter values, after that the filter values can be applied on project list
     * @memberof MyFilterModel
     */
    public copyChoicesToValues() {
        this.activeFilterValues = [];

        this.choices.forEach(filter => {
            if (filter.selected) {
                this.activeFilterValues.push(filter.label);
            }
        });

        this.refreshFilterBtnStates();
    }

    /**
     * reset only active filter values, so it would be different from selected filter choices
     * @memberof MyFilterModel
     */
    public resetValues() {
        this.activeFilterValues = [];
        this.refreshFilterBtnStates();
    }

    /**
     * reset all values to state where all choices and values are unselected
     * @memberof MyFilterModel
     */
    public resetAll() {
        this.activeFilterValues = [];
        this.choices.forEach(filter => {
            filter.selected = false;
        });

        this.isResetBtnActive = false;
        this.filterValueChanged = false;
    }
}


